const EventTypes = {
	LOGIN: "LOGIN",
	LOGOUT: "LOGOUT",
};

const EARTH_RADIUS_METERS = 6378137; // Earth's radius in meters
const KILOMETERS_PER_DEGREE = 111.3;
const DEGREES = {
	180: 180,
	360: 360,
};

const POLYGON_VALUES = {
	COLOR: {
		fill: "#2357be26",
		stroke: "#2357be",
	},
	RADIUS_DOT: 2.5,
	SCALE_VALUE: 0.95,
	CANVAS: {
		WIDTH: 130,
		HEIGHT: 150,
	},
};

// Constants
const CRM_SECTION_IDENTIFIER = "CustomerRelationsManagement";
const PROVIDERS_WITH_STORE_FEATURE = ["lojack"];

export {
	CRM_SECTION_IDENTIFIER,
	EventTypes,
	EARTH_RADIUS_METERS,
	KILOMETERS_PER_DEGREE,
	POLYGON_VALUES,
	DEGREES,
	PROVIDERS_WITH_STORE_FEATURE,
};
